<template>
<div class="con">
    <div class="title">
        <h2>수강신청 내역 확인하기</h2>
        <p>수강신청 취소는 1:1문의를 통해 문의 주시면 빠르게 처리 도와드리겠습니다.</p>
    </div>
    <div v-if="validTime && studentSubjectList.length > 0" class="mt-20">
        <table class="hq-table-col">
            <thead>
                <tr>
                    <th class="txt-center">No</th>
                    <th class="txt-center">클래스명</th>
                    <th class="txt-center">신청일</th>
                    <th class="txt-center" v-if="pay_status !=='X'">결제금액</th>
                    <th class="txt-center" v-if="pay_status !=='X'">결제수단</th>
                    <th class="txt-center" v-if="pay_status !=='X'">결제여부</th>
                    <th class="txt-center">상태</th>
                    <th class="txt-center" v-if="cancle_YN !=='N'">수강취소</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) of studentSubjectList" :key="index">
                    <td>{{studentSubjectList.length - index}}</td>
                    <td class="pointer txt-blue break-all" @click="openModal('detail', item)">{{item.subject_name || '-'}}</td>
                    <td class="bold">{{item.update_date.slice(0, 10)}}</td>
                    <td v-if="pay_status !=='X'">{{item.price || '-'}} 원</td>
                    <td v-if="pay_status !=='X'">{{formatPayWay(item.pay_way)}}</td>
                    <td 
                    v-if="pay_status !=='X'"
                    class="">
                        <span v-if="item.pay_status !== 'N'">
                            {{formatPayStatus(item.pay_status)}}
                        </span>
                        <span v-else class="txt-blue pointer" @click="payment(item)">
                            결제하기
                        </span>
                    </td>
                    <td>{{formatStatus(item.status)}}</td>
                    <td v-if="cancle_YN !=='N'">
                        <span class="pointer txt-blue" @click="openModal('cancel', item)" v-if="item.pay_status !=='X' && item.status !== 'C' && item.status !== 'F'">취소하기</span>
                        <span class="pointer txt-blue" @click="cancelSugang(item)" v-else-if="item.status !== 'C' && item.status !== 'F'">취소하기</span>
                        <span v-else>-</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="mt-50 txt-center" v-else-if="studentSubjectList.length === 0 && validTime">
        <p class="font-20">수강신청 내역이 없습니다.</p>
    </div>
    <div class="mt-50 txt-center" v-else>
        <p class="font-20">수강신청 내역 확인 기간이 지났습니다.</p>
    </div>
    <cancel-modal v-if="isCancelModalOpened" :parentCancelData="parentCancelData" :parentIdx="parentIdx" @close="closeModal" @refresh="refreshModal"></cancel-modal>
    <detail-process v-if="isDetailModalOpened" :parentData="parentData" :parentUser="user" @close="closeModal()"></detail-process>
</div>
</template>

<script>
import DetailProcess from '@/components/reg/applyList/detailModal.vue'
import CancelModal from '@/components/applyList/cancel.vue'
export default {
    components: {
        DetailProcess,
        CancelModal
    },
    data: () => ({
        validTime: true,
        studentSubjectList: [],
        isDetailModalOpened: false, // 클래스 상세보기 레이어팝업 on/off
        isCancelModalOpened: false, // 수강취소 레이어팝업 on/off
        onPaymentPage: true, // 결제 페이지 존재 여부
        parentData: {}, // 레이어팝업에 전달할 해당 강의 데이터
        parentIdx: '',
        parentCancelData: {},
        pay_status: '',
        cancle_YN: 'Y',
        cancleDate: 'Y',

        partialPay: '',
        payWay: '',
        user: {} // 해당 유저정보
    }),

    mounted() {
        // 수강신청 취소 기능 여부 (관리자단에서 설정시)
        this.cancle_YN = sessionStorage.getItem('cancle_YN')
        // 결제 페이지가 있는지 확인
        var pOrder = JSON.parse(sessionStorage.getItem('pOrder'))
        if (pOrder.includes('payment')) {
            this.onPaymentPage = true
        } else {
            this.onPaymentPage = false
        }

        // 수강신청 내역 api 호출
        var pageIdx = sessionStorage.getItem('pageIdx')
        var params = {
            pageIdx: pageIdx
        }

        if (sessionStorage.getItem('isAdmin') === true) {
            params['admin'] = 'Y'
        } else {
            params['admin'] = 'N'
        }

        this.axios.get(this.axios.root + this.axios.port + `/user/apply-history/${pageIdx}`, {
            params: params
        }).then(res => {
            // console.log('res', res)
            if (res.data.err === 0) {
                this.cancle_YN = res.data.cancleYN
                this.cancleDate = res.data.cancleDate
                this.studentSubjectList = res.data.studentSubjectList
                this.partialPay = res.data.partialPay
                this.payWay = res.data.payWay

                if (this.studentSubjectList.length > 0) {
                    this.pay_status = this.studentSubjectList[0].pay_status
                }
                this.user = res.data.user
            } else if (res.data.err === 105) {
                this.validTime = false
                alert(res.data.result)
            } else {
                alert(res.data.result)
            }
        }).catch(err => {
            // console.log(err)
            alert(err)
        })
    },

    methods: {
        payment(item) {
            var paymentData = {
                payment: item,
                user: this.user,
                payWay: this.payWay,
                partialPay: this.partialPay
            }
            sessionStorage.setItem('customPayment', JSON.stringify(paymentData))
            this.$router.push('/user/customPayment')
        },

        cancelSugang(data) {
            if (this.cancleDate === 'N') {
                alert('수강신청 취소 기간이 아닙니다.')
                return false
            }
            var subjectIdx = data.idx_itm_sugang_student_subject
            var params = {
                cardName: '',
                subjectIdx: subjectIdx
            }

            var con_test = confirm("해당 수강신청을 정말 취소하시겠습니까?");
            if (con_test == true) {
                this.axios.post(this.axios.root + this.axios.port + `/user/cancle-apply/${subjectIdx}`, params)
                    .then(res => {
                        // console.log('res', res)
                        this.fetchList()
                        alert('수강신청이 취소되었습니다')
                    })
            } else {
                return false
            }
        },

        // 클래스 상세보기 레이어팝업 열기
        openModal(type, data, cancelDate) {
            if (type === 'detail') {
                this.parentData = data
                this.isDetailModalOpened = true
            } else {
                if (this.cancleDate === 'N') {
                    alert('수강신청 취소 기간이 아닙니다.')
                    return false
                }
                this.isCancelModalOpened = true
                // console.log(data)
                this.parentCancelData = data
                this.parentIdx = data.idx_itm_sugang_student_subject
            }
        },

        // 모달 닫기
        closeModal() {
            if (this.isDetailModalOpened) {
                this.isDetailModalOpened = false
            } else {
                this.isCancelModalOpened = false
            }
        },

        refreshModal() {
            this.isCancelModalOpened = false
            this.fetchList()
        },

        fetchList() {
            var pageIdx = sessionStorage.getItem('pageIdx')
            var params = {
                pageIdx: pageIdx
            }

            if (sessionStorage.getItem('isAdmin') === true) {
                params['admin'] = 'Y'
            } else {
                params['admin'] = 'N'
            }

            this.axios.get(this.axios.root + this.axios.port + `/user/apply-history/${pageIdx}`, {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.studentSubjectList = res.data.studentSubjectList
                } else if (res.data.err === 105) {
                    this.validTime = false
                    alert(res.data.result)
                } else {
                    alert(res.data.result)
                }
            }).catch(err => {
                // console.log(err)
                alert(err)
            })
        },

        // 결제방법에 따른 한글 변환
        formatPayWay(status) {
            switch (status) {
                case 'C':
                    return '카드'
                case 'A':
                    return '계좌이체'
                default:
                    return '-'
            }
        },

        // payStatus에 따른 한글 변환
        formatPayStatus(status) {
            switch (status) {
                case 'Y':
                    return '결제완료'
                case 'N':
                    return '미결제'
                case 'X':
                    return '결제없음'
                case 'C':
                    return '결제취소'
                case 'P':
                    return '결제취소대기'
                default:
                    return '-'
            }
        },

        // status에 따른 한글 변환
        formatStatus(status) {
            switch (status) {
                case 'Y':
                    return '대기'
                case 'N':
                    return '신청완료'
                case 'C':
                    return '신청취소'
                case 'F':
                    return '실패'
                default:
                    return '-'
            }
        },
    }
}
</script>
